export default "__VITE_ASSET__DowYGBHp__"